import {SvgIconProps} from '@mui/material/SvgIcon';
import ImageIcon from '@mui/icons-material/Image';
import FileIcon from '@mui/icons-material/InsertDriveFile';
import React from 'react';
import {WordIcon} from '../icons/WordIcon';
import {PowerPointIcon} from '../icons/PowerPointIcon';
import {PDFIcon} from '../icons/PDFIcon';
import {OneNoteIcon} from '../icons/OneNoteIcon';
import {ExcelIcon} from '../icons/ExcelIcon';

type IconInfo = {icon: React.ComponentType<SvgIconProps>; color: string};

export const getFileIcon = (filename?: string): IconInfo => {
    const fileType = filename ? filename.split('.').pop() : '';

    switch (fileType) {
        case 'one':
            return {
                icon: OneNoteIcon,
                color: '#7C3876'
            };

        case 'pdf':
            return {
                icon: PDFIcon,
                color: '#F00000'
            };

        case 'ppt':
        case 'pptx':
            return {
                icon: PowerPointIcon,
                color: '#D24625'
            };

        case 'doc':
        case 'odt':
        case 'txt':
        case 'html':
        case 'docx':
            return {
                icon: WordIcon,
                color: '#2A5699'
            };

        case 'apng':
        case 'avif ':
        case 'gif':
        case 'jpeg':
        case 'png':
        case 'svg':
        case 'webp':
            return {
                icon: ImageIcon,
                color: '#666666'
            };

        case 'xls':
        case 'xlsx':
        case 'xlsm':
        case 'xlsb':
        case 'csv':
        case 'json':
            return {
                icon: ExcelIcon,
                color: '#11764B'
            };

        default:
            return {
                icon: FileIcon,
                color: '#666666'
            };
    }
};
